import {base, baseConfig} from "../Services/api";

export function create(obj) {
    const conf = {
        method: 'POST',
        body: JSON.stringify(obj),
        ...baseConfig
    };

    return fetch(`${base}campaigns`, conf);
}

export function filter(opts) {
  let url = new URL(`${base}campaigns/filter`);
  Object.keys(opts).forEach(key => url.searchParams.append(key, opts[key]));
  return fetch(url, baseConfig);
}

export function get() {
    return fetch(`${base}campaigns`, baseConfig);
}

export function getOne(id) {
    return fetch(`${base}campaigns/${id}`, baseConfig);
}

export function deleteOne(id) {
    const conf = {
        method: 'DELETE',
        ...baseConfig
    };
    return fetch(`${base}campaigns/${id}`, conf);
}

export function update(id, obj) {
    const conf = {
        method: 'PUT',
        body: JSON.stringify(obj),
        ...baseConfig
    };
    return fetch(`${base}campaigns/${id}`,conf);
}
